module.exports = __webpack_public_path__ + "/static/assets/0a0735cee319d9b8a35046cd3b609bc1.gif";